<template>
  <div class="page">
    <div class="d-flex flex-column sticky-1">
      <div class="input-group without-separator">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <font-awesome-icon icon="search" style="color:gray" />
          </span>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Поиск по марке, модели, рег. номеру, ФИО"
          aria-label="Поиск по марке, модели, рег. номеру, ФИО"
          :value="searchText"
          @input="searchRent"
        >
      </div>
      <div class="pt-2">
        <router-link to="/rent/create" class="btn btn-primary w-100">Сдать в аренду</router-link>
      </div>
    </div>

    <div class="card-body p-0 mt-3">
      <ul class="nav nav-tabs justify-content-center">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: currentTab === 'active' }"
            href="#active-rents"
            @click.prevent="setActiveTab()"
          >Активные</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: currentTab === 'closed' }"
            href="#closed-rents"
            @click.prevent="setClosedTab()"
          >Завершенные</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: currentTab === 'draft' }"
            href="#draft-rents"
            @click.prevent="setDraftTab()"
          >Черновики ({{ draftCount }})</a>
        </li>
      </ul>
      <div class="tab-content">
        <!--<ACTIVE CONTRACTS>-->
        <div id="active-rents" class="tab-pane fade" :class="{ 'active show': currentTab === 'active' }">
          <table class="table table-hover w-100 d-none d-md-table">
            <thead class="sticky-2">
              <tr>
                <th scope="col">№</th>
                <th>Автомобиль</th>
                <th>Водитель</th>
                <th>Организация</th>
                <th>Начало аренды</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="paginatedData.length === 0">
                <td colspan="5" style="text-align: center">Ничего не найдено</td>
              </tr>
              <tr
                v-for="contract of paginatedData"
                :key="contract.id"
                role="button"
                tabindex="0"
                class="tablerow"
                @click="$router.push(`/rent/${contract.id}`)"
              >
                <td scope="row">{{ contract.number }}</td>
                <td>
                  <TextHighlight class="highlighter" :queries="searchText">
                    {{ contract.car.brand }} {{ contract.car.model }} - {{ contract.car.registration_plate }}
                  </TextHighlight>
                </td>
                <td>
                  <TextHighlight class="highlighter" :queries="searchText">
                    {{ contract.driver.last_name }} {{ contract.driver.first_name }} {{ contract.driver.middle_name }}
                  </TextHighlight>
                </td>
                <td>{{ contract.company ? contract.company.name : '-' }}</td>
                <td>{{ contract.transfer_datetime | diffForHumans }}</td>
              </tr>
            </tbody>
          </table>
          <div v-for="contract of paginatedData" :key="contract.id" class="mobile-table-view card mt-2 mb-2 p-2 d-md-none">
            <table v-if="paginatedData.length > 0" class="table borderless">
              <tbody>
                <tr>
                  <td style="border-top: none">№</td>
                  <td style="border-top: none">
                    <TextHighlight class="highlighter" :queries="searchText">{{ contract.number }}</TextHighlight>
                  </td>
                </tr>
                <tr>
                  <td>Автомобиль</td>
                  <td>
                    <TextHighlight class="highlighter" :queries="searchText">
                      {{ contract.car.brand }} {{ contract.car.model }} - {{ contract.car.registration_plate }}
                    </TextHighlight>
                  </td>
                </tr>
                <tr>
                  <td>Водитель</td>
                  <td>
                    <TextHighlight class="highlighter" :queries="searchText">
                      {{ contract.driver.last_name }} {{ contract.driver.first_name }} {{ contract.driver.middle_name }}
                    </TextHighlight>
                  </td>
                </tr>
                <tr>
                  <td>Организация</td>
                  <td>{{ contract.company ? contract.company.name : '-' }}</td>
                </tr>
                <tr>
                  <td>Начало аренды</td>
                  <td>{{ contract.transfer_datetime | diffForHumans }}</td>
                </tr>
              </tbody>
            </table>
            <router-link
              :to="{ name: 'rentPage', params: { contractId: contract.id } }"
              class="btn btn-primary btn-md ml-auto"
            >
              Подробно
            </router-link>
          </div>
        </div>
        <!--</ACTIVE CONTRACTS>-->

        <!--<CLOSED CONTRACTS>-->
        <div id="closed-rents" class="tab-pane fade" :class="{ 'active show': currentTab === 'closed' }">
          <ClosedRents :closed-contracts="paginatedData" :search-text="searchedText" />
        </div>
        <!--</CLOSED CONTRACTS>-->
        <!--<DRAFT CONTRACTS>-->
        <div id="draft-rents" class="tab-pane fade" :class="{ 'active show': currentTab === 'draft' }">
          <table class="table table-hover w-100 d-none d-md-table">
            <thead class="sticky-2">
              <tr>
                <th>Автомобиль</th>
                <th>Водитель</th>
                <th>Организация</th>
                <th>Окончание аренды</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="paginatedData.length === 0">
                <td colspan="4" style="text-align: center">Ничего не найдено</td>
              </tr>
              <tr
                v-for="contract of paginatedData"
                :key="contract.id"
                class="tablerow"
                @click="$router.push(`/rent/${contract.id}`)"
              >
                <td>
                  <TextHighlight class="highlighter" :queries="searchText">
                    {{ contract.car.brand }} {{ contract.car.model }} - {{ contract.car.registration_plate }}
                  </TextHighlight>
                </td>
                <td>
                  <TextHighlight class="highlighter" :queries="searchText">
                    {{ contract.driver.last_name }} {{ contract.driver.first_name }} {{ contract.driver.middle_name }}
                  </TextHighlight>
                </td>
                <td>{{ contract.company ? contract.company.name : '-' }}</td>
                <td>{{ contract.receiving_datetime | diffForHumans }}</td>
              </tr>
            </tbody>
          </table>
          <div v-for="contract of paginatedData" :key="contract.id" class="mobile-table-view card mt-2 mb-2 p-2 d-md-none">
            <table v-if="paginatedData.length > 0" class="table borderless">
              <tbody>
                <tr>
                  <td style="border-top: none">№</td>
                  <td style="border-top: none">
                    <TextHighlight class="highlighter" :queries="searchText">{{ contract.number }}</TextHighlight>
                  </td>
                </tr>
                <tr>
                  <td>Автомобиль</td>
                  <td>
                    <TextHighlight class="highlighter" :queries="searchText">
                      {{ contract.car.brand }} {{ contract.car.model }} - {{ contract.car.registration_plate }}
                    </TextHighlight>
                  </td>
                </tr>
                <tr>
                  <td>Водитель</td>
                  <td>
                    <TextHighlight class="highlighter" :queries="searchText">
                      {{ contract.driver.last_name }} {{ contract.driver.first_name }} {{ contract.driver.middle_name }}
                    </TextHighlight>
                  </td>
                </tr>
                <tr>
                  <td>Организация</td>
                  <td>{{ contract.company ? contract.company.name : '-' }}</td>
                </tr>
                <tr>
                  <td>Окончание аренды</td>
                  <td>{{ contract.receiving_datetime | diffForHumans }}</td>
                </tr>
              </tbody>
            </table>
            <router-link
              :to="{ name: 'rentPage', params: { contractId: contract.id } }"
              class="btn btn-primary btn-md ml-auto"
            >
              Подробно
            </router-link>
          </div>
        </div>
        <!--</DRAFT CONTRACTS>-->
      </div>
      <div class="pagination-rent">
        <div class="pagination-page" @click="prevPage">Назад</div>
        <div
          v-for="i in pagesCount"
          :key="i"
          @click="pageNumber = i - 1"
        >
          <div
            v-if="(pagesCount <= 10 || (pagesCount > 10 && ((i > pageNumber - 3) && (i < pageNumber + 7))))"
            class="pagination-page"
            :class="i - 1 === pageNumber ? 'pagination-page-active' : ''"
          >
            {{ i }}
          </div>
        </div>
        <div class="pagination-page" @click="nextPage">Дальше</div>
      </div>
    </div>
  </div>
</template>

<script>
import { djsMixin } from '@/mixins/djsMixin'
import { mapState, mapActions, mapGetters } from 'vuex'
import ClosedRents from '../../components/contracts/rent/ClosedRents'
export default {
  name: 'Contracts',
  components: {ClosedRents},
  mixins: [djsMixin],
  props: {
    page: {
      type: String,
      default: () => '1'
    }
  },
  data () {
    return {
      searchedText: null,
      interval: null,
      pageNumber: 0,
      size: 50
    }
  },
  computed: {
    ...mapState('taxi/contracts', {
      pageCount: state => state.pageCount,
      isLoading: state => state.isLoading,
      searchText: state => state.searchText,
      draftCount: state => state.draftCount,
      currentTab: state => state.currentTab
    }),
    pagesCount (){
      let l = this.pageData.length,
        s = this.size
      return Math.ceil(l/s)
    },
    paginatedData (){
      const start = this.pageNumber * this.size,
        end = start + this.size
      return this.pageData.slice(start, end)
    },
    pageData () {
      if (this.currentTab === 'draft') {
        return this.draftContracts
      } else if (this.currentTab === 'closed') {
        return this.closedContracts
      } else {
        return this.activeContracts
      }
    },
    ...mapGetters('taxi/contracts', [
      'activeContracts',
      'closedContracts',
      'draftContracts'
    ])
  },
  watch: {
    page () {
      this.loadItems({ page: Number(this.page) })
    },
    currentTab () {
      this.loadCurrentTab()
    },
  },
  mounted () {
    this.loadAllTabs()
    this.setTitle([
      {
        title: 'Аренда'
      }
    ])
    if (!this.interval) {
      this.loadWithSearch()
    }
  },
  beforeDestroy () {
    this.abortLoading()
    clearTimeout(this.interval)
    this.interval = null
  },
  methods: {
    ...mapActions('taxi/contracts', [
      'loadCurrentTab',
      'setSearchText',
      'loadAllTabs',
      'setActiveTab',
      'setClosedTab',
      'setDraftTab',
      'abortLoading',
      'removeItem'
    ]),
    loadWithSearch () {
      if (!this.isLoading && this.searchedText !== this.searchText) {
        this.searchedText = this.searchText
        return this.loadCurrentTab()
          .then(() => {
            this.interval = setTimeout(() => { this.loadWithSearch() }, 500)
          })
      }
      this.interval = setTimeout(() => { this.loadWithSearch() }, 500)
    },
    searchRent (e) {
      this.setSearchText(e.target.value)
    },
    nextPage(){
      if (this.pageNumber < this.pagesCount - 1) {
        this.pageNumber++
      }
    },
    prevPage(){
      if (this.pageNumber > 0) {
        this.pageNumber--
      }
    },
    ...mapActions('taxi', [
      'setTitle'
    ])
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 1199px) {
    .page {
      padding: 1rem;
    }
  }
  @media screen and (max-width: 576px) {
    .page {
      padding: 0.5rem;
    }
  }
  .card-header .btn-link {
    color: #0597f2;
  }
  .card-header {
    background-color: white !important;
  }
  .card-header {
    padding-bottom: 0;
  }
  th {
    font-weight: 600;
    font-size: 15.7px;
  }
  .highlighter ::v-deep .text__highlight {
    border-radius: 0px;
    padding: 0.2em 0 0.2em 0;
    background: #fff2ae;
  }
  .closed-table {
    td {
      word-break: break-word;
    }
    .closed-number-col {
      word-break: keep-all;
    }
  }
  .pagination-page {
    background: #f9f9f9;
    padding: 10px 15px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ced4da;
    cursor: pointer;
  }
  .pagination-rent {
    display: flex;
    place-content: center;
  }
  .pagination-page-active {
    background: #c3c3c3;
    border-color: #8d8c8c;
  }
</style>
